import Logo from "./Logo";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer>
      {/* Main footer */}
      <div className="bg-[#1e2a5e] py-12 border-t border-white/20">
        <div className="max-w-[1400px] mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
            {/* Contact info */}
            <div className="space-y-5">
              <div className="flex items-start gap-3">
                <span className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-white text-lg"></i>
                </span>
                <a
                  href="tel:360-206-7120"
                  className="text-white font-bold text-sm hover:underline"
                >
                  (360) 206-7120
                </a>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-mail-line text-white text-lg"></i>
                </span>
                <a
                  href="mailto:husmamprollc@hotmail.com"
                  className="text-white font-bold text-sm hover:underline"
                >
                  husmamprollc@hotmail.com
                </a>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-white text-lg"></i>
                </span>
                <a
                  href="https://www.google.com/maps/place/307+S+Steele+Ave,+Picayune,+MS+39466"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white font-bold text-sm hover:underline"
                >
                  307 S Steele Ave, Picayune, MS 39466
                </a>
              </div>
            </div>

            {/* Logo */}
            <div className="flex justify-center">
              <Logo variant="light" size="lg" />
            </div>

            {/* Store hours */}
            <div>
              <h4 className="text-white font-bold text-sm mb-4 uppercase tracking-wide">
                Store Hours
              </h4>
              <div className="text-white/80 text-xs space-y-1 leading-relaxed">
                <p>MONDAY: 10 am – 6 pm</p>
                <p>TUESDAY: 10 am – 6 pm</p>
                <p>WEDNESDAY: 10 am – 6 pm</p>
                <p>THURSDAY: 10 am – 6 pm</p>
                <p>FRIDAY: 10 am – 6 pm</p>
                <p>SATURDAY: 10 am – 4 pm</p>
                <p>SUNDAY: 10 am – 3 pm</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright bar */}
      <div className="bg-[#152045] py-4 border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-4 text-center space-y-2">
          <p className="text-white/70 text-xs">
            Copyright © 2026 ATLAS PRO SERVICES LLC. All Rights Reserved.
          </p>
          
        </div>
      </div>
    </footer>
  );
}